module.exports = __webpack_public_path__ + "img/transport-pathyway.0be7cb1a.jpg";